export const en = {
    intlLocale: 'en-GB',
    words: {
        session: 'session',
        booking: 'booking',
        waitlist: 'waitlist',
        membership: 'membership',
        membershipPlan: 'membership plan',
        taster: 'free taster class',
        trialPeriod: 'free period',
        classType: 'class type',
        danceRole: 'dance role',
        lead: 'lead',
        follow: 'follow',
        school: 'school',
        operator: 'Rythmo operator',
    },
    // CONTEXT.md: one word per role in each language, never a synonym.
    roles: {
        OWNER: 'owner',
        MANAGER: 'manager',
        TEACHER: 'teacher',
        MEMBER: 'member',
    },
    credits: { one: '{n} credit', other: '{n} credits' },
    unknownProblem: 'Something went wrong. Try again in a moment.',
    problems: {
        // Identity and school selection
        'urn:rythmo:problem:no-grant-at-school': 'You don’t have access to this school.',
        'urn:rythmo:problem:school-not-named': 'Choose a school to continue.',
        // Booking
        'urn:rythmo:problem:no-credits': 'You have no credits left. Top up your membership, or buy one, to book.',
        'urn:rythmo:problem:taster-already-used': 'You’ve already used your free taster class.',
        'urn:rythmo:problem:already-booked': 'You’ve already booked this session.',
        'urn:rythmo:problem:not-a-member': 'You’re not a member of this school yet.',
        'urn:rythmo:problem:booking-not-cancellable': 'This booking can’t be cancelled any more.',
        'urn:rythmo:problem:booking-not-claimable': 'This seat is no longer waiting to be claimed. Check your booking to see where it stands.',
        'urn:rythmo:problem:session-not-bookable': 'This session can’t be booked: it has been cancelled or has already started.',
        'urn:rythmo:problem:dance-role-required': 'Choose lead or follow to book this session.',
        'urn:rythmo:problem:dance-role-not-accepted': 'This session doesn’t take a dance role. Book it without one.',
        // The school's payments
        'urn:rythmo:problem:school-cannot-accept-payments': 'This school can’t take payments yet. Ask the school, or try again later.',
        // Buying and holding a membership
        'urn:rythmo:problem:membership-already-active': 'You already have an active membership. Top it up or change your plan instead.',
        'urn:rythmo:problem:plan-has-no-quota': 'This membership plan isn’t ready to sell yet. Ask the school.',
        'urn:rythmo:problem:no-active-membership': 'You don’t have a membership to top up. Buy one first.',
        'urn:rythmo:problem:membership-has-no-plan': 'Your membership was given to you by the school, so it can’t be topped up here. Ask the school.',
        'urn:rythmo:problem:plan-retired': 'The school no longer sells your membership plan. Choose another one.',
        'urn:rythmo:problem:plan-is-recurring': 'Your membership renews by itself, so it can’t be topped up. Change your plan instead.',
        'urn:rythmo:problem:plan-trial-not-supported': 'This membership plan can’t be bought here yet. Ask the school.',
        'urn:rythmo:problem:membership-payment-overdue': 'A payment on your membership is overdue. Pay it to continue.',
        'urn:rythmo:problem:no-membership': 'You don’t have a membership at this school yet.',
        'urn:rythmo:problem:membership-not-cancellable': 'This membership can’t be cancelled any more.',
        'urn:rythmo:problem:no-billing-account': 'You haven’t paid this school online yet.',
        // Changing plan
        'urn:rythmo:problem:membership-not-recurring': 'Only a membership that renews can change plan.',
        'urn:rythmo:problem:plan-not-recurring': 'You can only change to a membership plan that renews.',
        'urn:rythmo:problem:plan-unchanged': 'You’re already on this membership plan.',
        'urn:rythmo:problem:plan-change-queued': 'You already have a plan change waiting for your next renewal.',
        'urn:rythmo:problem:plan-change-awaiting-payment': 'Your last plan change is waiting for a payment. Finish it first.',
        'urn:rythmo:problem:no-plan-change-queued': 'You have no plan change waiting.',
        'urn:rythmo:problem:plan-upgrade-waits-for-renewal': 'You can upgrade once your free period ends.',
        'urn:rythmo:problem:plan-change-settling': 'Your last change is still going through. Try again in a minute.',
        'urn:rythmo:problem:subscription-not-changeable': 'This membership can’t be changed here. Ask the school.',
        // Refunds
        'urn:rythmo:problem:membership-not-refundable': 'This membership can’t be refunded from Rythmo. Refund it from the Stripe Dashboard.',
        'urn:rythmo:problem:refund-exceeds-payment': 'That’s more than this payment can still return. Enter a smaller amount.',
        // Card payments
        'urn:rythmo:problem:payment-declined': 'Your card was declined. Try another card or contact your bank.',
        'urn:rythmo:problem:payment-provider-unavailable': 'Payments are unavailable for a moment. Try again shortly.',
        'urn:rythmo:problem:payment-provider-error': 'The payment couldn’t be completed. Try again later, or ask the school.',
    },
};
//# sourceMappingURL=en.js.map